import React from 'react';
import style from "./PropertyDetails.module.css";
import { DateRangePicker } from 'react-date-range';
import 'react-date-range/dist/styles.css'; // main css file
import 'react-date-range/dist/theme/default.css'; // theme css file
// import { addDays } from 'date-fns';
import { useState, useEffect } from 'react';
import './callender.css';
import i18n, { t } from 'i18next';
import * as locales from 'react-date-range/dist/locale';
import moment from 'moment';
export default function Callender({ selectedValue, checkIn, checkOut ,/* setVisibleToast */}) {
    const [arr, setArr] = useState([])
    // const [state, setState] = useState({
    //     selection1: {
    //         startDate: addDays(new Date(), -6),
    //         endDate: new Date(),
    //         key: 'selection1'
    //     },
    //     selection2: {
    //         startDate: addDays(new Date(), 1),
    //         endDate: addDays(new Date(), 7),
    //         key: 'selection2'
    //     }
    // });
    const [state, setState] = useState([
        {
            startDate: null,
            endDate: new Date(""),
            key: 'selection'
        }
    ]);
    useEffect(() => {
        var dates = [...arr];
        selectedValue.map((e) => {
            var start_date = moment(e.check_in).startOf('day').subtract(1, 'days');
            var end_date = moment(e.check_out).startOf('day').add(1, 'days');
            while (start_date.add(1, 'days').diff(end_date) < 0) {
                dates.push(new Date(moment(start_date.clone().toDate()).format('YYYY-MM-DD')));
            }
            setArr(dates);
            return dates;
        })
        setArr(dates)
        // eslint-disable-next-line
    }, [])
    function callenderChangeHandler(item) {
        setState([item.selection]);
        moment(checkIn(item.selection.startDate)).format('E, d MMM y');
        moment(checkOut(item.selection.endDate)).format('E, d MMM y')
        // setVisibleToast(true)
    }
    return (
        <div>
            <div className='d-none d-lg-block p-5' dir='ltr'>
                <DateRangePicker
                    onChange={(item) => callenderChangeHandler(item)}
                    showSelectionPreview={false}
                    disabledDates={arr}
                    minDate={new Date()}
                    ranges={state}
                    moveRangeOnFirstSelection={false}
                    months={2}
                    editableDateInputs={false}
                    direction="horizontal"
                    locale={locales[i18n.language === 'ar' ? 'arSA' : 'enGB']}
                />
                <div className={`${style.sortingDates}`}>
                    <div>
                        <button className={`${style.selectedRoomBtn}`}></button>
                        <span>{t('Selected-dates')}</span>
                    </div>
                    <div>
                        <button className={`${style.availableRoomBtn}`}></button>
                        <span>{t('Available-room')}</span>
                    </div>
                    <div>
                        <button className={`${style.selectedDatedBtn}`}></button>
                        <span>{t('not-available')}</span>
                    </div>

                </div>

            </div>
            <div className='d-lg-none'>
                <DateRangePicker
                    onChange={(item) => callenderChangeHandler(item)}
                    showSelectionPreview={false}
                    disabledDates={arr}
                    minDate={new Date()}
                    ranges={state}
                    moveRangeOnFirstSelection={false}
                    months={1}
                    editableDateInputs={false}
                    direction="horizontal"
                    locale={locales[i18n.language === 'ar' ? 'arSA' : 'enGB']}
                />
                <div className={`${style.sortingDates} mt-4 me-0`}>
                    <div>
                        <button className={`${style.selectedRoomBtn}`}></button>
                        <span>{t('Selected-dates')}</span>
                    </div>
                    <div>
                        <button className={`${style.availableRoomBtn}`}></button>
                        <span>{t('Available-room')}</span>
                    </div>
                    <div>
                        <button className={`${style.selectedDatedBtn}`}></button>
                        <span>{t('not-available')}</span>
                    </div>

                </div>

            </div>


        </div>
    )
}
